import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Yw from '@/pages/yw'
import My from '@/pages/my'
import Service from '@/pages/service'
import Serviceway from '@/pages/serviceway'
import Appointment from '@/pages/appointment'
import Door from '@/pages/door'
import Realinfo from '@/pages/realinfo'
import Newsinfo from '@/pages/newsinfo'
import Doorlist from '@/pages/doorlist'
import Ywlist from '@/pages/ywlist'
import Verifylist from '@/pages/verifylist'
import Verifyinfo from '@/pages/verifyinfo'
import Appointmentlist from '@/pages/appointmentlist'
import Doorinfo from '@/pages/doorinfo'
import Appointmentinfo from '@/pages/appointmentinfo'
import Xz from '@/pages/Xz'
const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/Yw',
      name: 'Yw',
      component: Yw
    },
    {
      path: '/My',
      name: 'My',
      component: My
    },
	{
	  path: '/Service',
	  name: 'Service',
	  component: Service
	},
  {
    path: '/Serviceway',
    name: 'Serviceway',
    component: Serviceway
  },
  {
    path: '/Appointment',
    name: 'Appointment',
    component: Appointment
  },
  {
    path: '/Door',
    name: 'Door',
    component: Door
  },
  {
    path: '/Realinfo',
    name: 'Realinfo',
    component: Realinfo
  },
  {
    path: '/Newsinfo',
    name: 'Newsinfo',
    component: Newsinfo
  },
  {
    path: '/Doorlist',
    name: 'Doorlist',
    component: Doorlist
  },
  {
    path: '/Ywlist',
    name: 'Ywlist',
    component: Ywlist
  },
  {
    path: '/Appointmentlist',
    name: 'Appointmentlist',
    component: Appointmentlist
  },
  {
    path: '/Verifylist',
    name: 'Verifylist',
    component: Verifylist
  },
  {
    path: '/Verifyinfo',
    name: 'Verifyinfo',
    component: Verifyinfo
  },
  {
    path: '/Doorinfo',
    name: 'Doorinfo',
    component: Doorinfo
  },
  {
    path: '/Appointmentinfo',
    name: 'Appointmentinfo',
    component: Appointmentinfo
  },
  {
    path: '/Xz',
    name: 'Xz',
    component: Xz
  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js